import { Activity } from "lucide-react";
import type { ReaderWorkspace } from "../reader/reader-workspace";

export function MonitorPage({ workspace }: { workspace: ReaderWorkspace }) {
  return (
    <section className="space-y-3">
      <div>
        <h1 className="flex items-center gap-2 text-lg font-semibold">
          <Activity className="size-4" />
          运行状态
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">书源健康和最近遥测</p>
      </div>
      <div className="space-y-2 border-y py-3">
        <p className="text-xs font-medium text-muted-foreground">Telemetry</p>
        <div className="space-y-2">
          {workspace.telemetry.length === 0 ? (
            <p className="text-xs text-muted-foreground">暂无用户遥测</p>
          ) : (
            workspace.telemetry.map(event => (
              <div key={event.id} className="text-xs">
                <span className="font-semibold">{event.name}</span>
                <span className="ml-2 text-muted-foreground">{event.type}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
